'use client'

import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { formatCurrency } from '@okra/shared'
import { OverdueSummaryBanner } from '@/components/credit/overdue-summary-banner'
import { KpiCard } from '@/components/stats/kpi-card'

interface DashboardSummary {
  totalRevenue: number
  totalSalesCount: number
  totalClients: number
  lowStockCount: number
  overdueCount: number
}

export default function DashboardPage() {
  const { data: summary } = useQuery<DashboardSummary>({
    queryKey: ['stats-dashboard'],
    queryFn: () => api.get('/stats/dashboard'),
  })

  return (
    <div className="space-y-6">
      <OverdueSummaryBanner />

      <h1 className="text-2xl font-bold">Tableau de bord</h1>

      {summary && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <KpiCard
            title="Chiffre d'affaires"
            value={formatCurrency(summary.totalRevenue)}
            subtitle="Ventes facturées"
          />
          <KpiCard
            title="Ventes"
            value={summary.totalSalesCount}
            subtitle="Facturées / partiellement payées / payées"
          />
          <KpiCard
            title="Clients"
            value={summary.totalClients}
            subtitle="Actifs"
          />
          <KpiCard
            title="Produits en rupture"
            value={summary.lowStockCount}
            subtitle="Stock ≤ 0"
            className={summary.lowStockCount > 0 ? 'border-destructive/50 bg-destructive/5' : ''}
          />
        </div>
      )}
    </div>
  )
}
